module.exports = __webpack_public_path__ + "img/check.2d96b9a5.svg";